module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"entering_year":"Joined in %{year}","graduate":"graduate","from":"From %{school}"}}}')
  delete Component.options._Ctor
}
